import Cleave from 'cleave.js';

// Short aliases for JS selectors
const query = document.querySelector.bind(document);

// Forms validation
const inputBlik = new Cleave('#input-blik-number', {
   numericOnly: true,
   delimiter: '  ',
   blocks: [1, 1, 1, 0, 1, 1, 1]
});

const inputPaymentCardNumber = new Cleave('#input-payment-card-number', {
  creditCard: true,
  onCreditCardTypeChanged: function (type) {
    const cardTypeParent = query('.payment-card-type');

    // console.log(type);

    // examples:
    // maestro: 6759 6498 2643 8453
    // mastercard: 5500 0000 0000 0004
    // visa: 	4111 1111 1111 1111

    if(type == 'unknown'){
      cardTypeParent.classList.remove('selected');
      if(query('.active')){
        query('.active').classList.remove('active');
      }
    } else {
      cardTypeParent.classList.add('selected');
      const cardType = query('.payment-card-' + type);
      if(cardType){
        cardType.classList.add('active');
      }
    }
  }
});

const inputPaymentCardExpiry = new Cleave('#input-payment-card-expiry-date', {
  date: true,
  datePattern: ['m', 'y']
});

const inputPaymentCardCode = new Cleave('#input-payment-card-code', {
  numericOnly: true,
  blocks: [3]
});
